export default __webpack_public_path__ + "static/media/imessage-icon.3118d776.svg";